<template>
  <div>
    <!-- <div class="day">
      <span class="number">{{ days }}</span>
      <div class="format">{{ wordString.day }}</div>
    </div>
    <div class="hour">
      <span class="number">{{ hours }}</span>
      <div class="format">{{ wordString.hours }}</div>
    </div>
    <div class="min">
      <span class="number">{{ minutes }}</span>
      <div class="format">{{ wordString.minutes }}</div>
    </div>
    <div class="sec">
      <span class="number">{{ seconds }}</span>
      <div class="format">{{ wordString.seconds }}</div>
    </div>
    <div class="message">{{ message }}</div>
    <div class="status-tag" :class="statusType">{{ statusText }}</div>-->
    <!-- <p class="p-0 m-0 status-Type" v-if="statusType == 'upcoming'">{{bidType}} Starts on</p>
    <p class="p-0 m-0 status-Type" v-if="statusType == 'Live'">Live</p>-->
    <div class="p-0 m-0" v-if="statusType != 'Expired'">
      <span class="status-text" v-if="statusType == 'Upcoming'">Starts in :</span>
      <span class="status-text" v-if="statusType == 'Live'">Ends in :</span>
      <img class="pl-1 image" src="../assets/timer.svg" />
      <span class="status-Type" v-if="days">{{days}}d</span>
      <span class="status-Type" v-if="hours">{{hours}}h</span>
      <span class="status-Type" v-if="minutes">{{minutes}}m</span>
      <span class="status-Type" v-if="seconds">{{seconds}}s</span>
      <!-- <span
        class="status-Type"
        v-if="days == 0 && hours == 0 && minutes == 0 && seconds == 0"
      >Expired</span>-->
    </div>
  </div>
</template>


<script>
export default {
  props: ["starttime", "endtime", "trans", "bidType", "currentIndex"],
  data() {
    return {
      timer: "",
      wordString: {},
      start: "",
      end: "",
      interval: "",
      days: "",
      minutes: "",
      hours: "",
      seconds: "",
      message: "",
      statusType: "",
      statusText: ""
    };
  },
  created() {
    // this.wordString = JSON.parse(this.trans);
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
    if (this.start == this.end) {
      // this.$emit("timer", "Expired");
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
      var bidStatus = {
        bidType: this.bidType,
        action: "Expired",
        index: this.currentIndex
      };
      this.$emit("timer", bidStatus);
    } else {
      this.timerCount(this.start, this.end);
      this.interval = setInterval(() => {
        this.timerCount(this.start, this.end);
      }, 1000);
    }
  },
  methods: {
    timerCount(start, end) {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date

      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        this.statusType = "Expired";
        var bidStatus = {
          bidType: this.bidType,
          action: "Expired",
          index: this.currentIndex
        };
        this.$emit("timer", bidStatus);
        clearInterval(this.interval);
        return;
      } else if (distance < 0 && passTime > 0) {
        // console.log("RUNNING");
        this.calcTime(passTime);
        this.statusType = "Live";
        var bidStatus = {
          bidType: this.bidType,
          action: "Live",
          index: this.currentIndex
        };
        this.$emit("timer", bidStatus);
      } else if (distance > 0 && passTime > 0) {
        // console.log("UPCOMING", distance);
        this.calcTime(distance);
        this.statusType = "Upcoming";
        var bidStatus = {
          bidType: this.bidType,
          action: "Upcoming",
          index: this.currentIndex
        };
        this.$emit("timer", bidStatus);
      }
    },
    calcTime(dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      // console.log(this.days);
      this.hours = Math.floor(
        (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      // console.log(this.minutes);
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
      // console.log(this.seconds);
    },
    checkStatusType(status) {
      if (status == "live") {
        return "live-background";
      } else if (status == "Upcoming") {
        return "upcoming-background";
      } else {
        return "background";
      }
    }
  }
};
</script>
<style scoped>
.image {
  height: 15px;
}
.status-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
}
.status-Type {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  padding: 1px;
  font-weight: 600;
  text-align: left;
  padding-left: 1%;
  font-weight: 600;
}
.background {
  width: 80%;
  height: 23px;
  border-radius: 83px;
  background-color: #d1e7ff;
}
.completed-background {
  width: 8vw;
  height: 23px;
  border-radius: 83px;
  background-color: #d1e7ff;
}
.live-background {
  border: none;
  border-radius: 83px;
  background-color: #28b91533;
  color: #62a94b;
  width: 80%;
  height: 23px;
}
.upcoming-background {
  width: 75%;
  height: 23px;
  border-radius: 83px;
  background-color: #28b915;
}
@media screen and (min-device-width: 1200px) and (max-device-width: 1470px) {
  .live-background {
    width: 100% !important;
  }
  .background {
    width: 100% !important;
  }
}
</style>